import { AfterContentInit, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { AnalyticsHelperService } from "../../services/analytics-helper.service";
import { HeroService } from "../../services/hero.service";

@Component({
    selector: "app-what-is-epi-page",
    templateUrl: "./what-is-epi-page.component.html",
    styleUrls: ["./what-is-epi-page.component.scss"]
})
export class WhatIsEpiPageComponent implements OnInit, AfterContentInit {
    public leavingSite: boolean = false;
    public url: string;

    @ViewChild("hero", { static: true }) hero: ElementRef;

    constructor(public heroService: HeroService, private analyticsHelper: AnalyticsHelperService) {}

    ngOnInit(): void {}

    ngAfterContentInit() {
        this.heroService.setHero(this.hero);

        this.analyticsHelper.trackPageLoad("what-is-epi");
    }

    public leaveSite(url: string) {
        this.leavingSite = true;
        this.url = url;
    }

    public closeLeavingSiteModal() {
        this.leavingSite = false;
    }

    public track(id: string): void {
        this.analyticsHelper.trackInteraction(id);
    }
}
